export default "__VITE_ASSET__284143ea__"